interface ProductDescription {
  type: string;
  standardMaterial: string;
  pressure: string;
  temperature: string;
  surfaceSpeed: string;
  stock: number;
  unlimited: boolean;
}

interface ProductDescriptionCardProps {
  index: number;
  description: ProductDescription;
  setDescriptions: React.Dispatch<React.SetStateAction<ProductDescription[]>>;
  onDelete: () => void;
}

export default function ProductDescriptionCard({
  index,
  description,
  setDescriptions,
  onDelete,
}: ProductDescriptionCardProps) {

  const handleChange = (
    field: keyof ProductDescription,
    value: string | number | boolean
  ) => {
    setDescriptions((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              [field]: value,
            }
          : item
      )
    );
  };
  return (
    <div className="rounded-2xl border border-gray-100 p-6 shadow-sm">
      <div className="mb-6 flex items-center justify-between">
        <h3 className="text-lg font-semibold">Description {index + 1}</h3>

        {index !== 0 && (
          <button
            onClick={onDelete}
            type="button"
            className="rounded-lg bg-red-500 px-4 py-2 text-sm text-white hover:bg-red-600">
            Delete
          </button>
        )}
      </div>

      

      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="mb-2 block">Type</label>

          <input
            value={description.type}
            onChange={(e) => handleChange("type", e.target.value)}
            className="h-12 w-full rounded-xl border px-4"
            placeholder="Type..."
          />
        </div>

        <div>
          <label className="mb-2 block">Standard Material</label>

          <input
            value={description.standardMaterial}
            onChange={(e) => handleChange("standardMaterial", e.target.value)}
            className="h-12 w-full rounded-xl border px-4"
            placeholder="Standard Material..."
          />
        </div>

        <div>
          <label className="mb-2 block">Pressure</label>

          <input
            value={description.pressure}
            onChange={(e) => handleChange("pressure", e.target.value)}
            className="h-12 w-full rounded-xl border px-4"
            placeholder="Pressure..."
          />
        </div>

        <div>
          <label className="mb-2 block">Temperature</label>

          <input
            value={description.temperature}
            onChange={(e) => handleChange("temperature", e.target.value)}
            className="h-12 w-full rounded-xl border px-4"
            placeholder="Temperature..."
          />
        </div>

        <div>
          <label className="mb-2 block">Surface Speed</label>

          <input
            value={description.surfaceSpeed}
            onChange={(e) => handleChange("surfaceSpeed", e.target.value)}
            className="h-12 w-full rounded-xl border px-4"
            placeholder="Surface Speed..."
          />
        </div>

        <div>
          <label className="mb-2 block">Stock</label>

          <input
            type="number"
            value={description.stock}
            onChange={(e) => handleChange("stock", Number(e.target.value))}
            className="h-12 w-full rounded-xl border px-4"
            placeholder="0"
          />
        </div>
      </div>

      <div className="mt-6 flex justify-end gap-3">
        <span>Unlimited</span>

        <input
          type="checkbox"
          checked={description.unlimited}
          onChange={(e) => handleChange("unlimited", e.target.checked)}
        />
      </div>
    </div>
  );
}
